import request from "@/utils/request";
import axios from "axios";
import {getToken} from "@/utils/token";

// 上传图片
function uploadImage(data){
    // return request({
    //     url:'/upload-image',
    //     data:data,
    //     method:'post',
    //     headers: { "Content-Type": "multipart/form-data", }
    // })
    return axios({
        method: 'post',
        headers: { "Content-Type": "multipart/form-data" , Authorization:'Bearer'+getToken()},
        baseURL: process.env.VUE_APP_BASE_API,
        timeout: 30 * 1000,
        traditional:true,
        url: '/upload-image',
        data: data,
        onUploadProgress: function (progressEvent){
            // return getProcess(progressEvent,pf)
        },
        onDownloadProgress: function (progressEvent) {
            // 处理原生进度事件
            console.log("onDownloadProgress",progressEvent)
        },
    });
}


export {
    uploadImage
}
